import React from "react";
import { Box, Grid2, Typography } from "@mui/material";

const InfoField = ({ label, value, size = 6, mobileSize, multiline = false }) => (
	<Grid2 item size={{ xs: mobileSize || Math.max(size, 6), md: size }}>
		<Box
			sx={{
				p: 1.5,
				bgcolor: "white",
				borderRadius: 1,
				border: "1px solid #e0e0e0",
				minWidth: 0,
				overflow: "hidden",
			}}
		>
			<Typography
				variant="caption"
				sx={{ color: "text.secondary", display: "block", mb: 0.5 }}
			>
				{label}
			</Typography>
			<Typography
				variant="body2"
				sx={{
					fontWeight: 500,
					wordBreak: "break-word",
					overflowWrap: "break-word",
				}}
			>
				{value || "N/A"}
			</Typography>
		</Box>
	</Grid2>
);

export default InfoField;
